<main class="container-notifications">
  <section class="title-notifications">Notificaciones</section>
  <section class="second-container" *ngIf="(activitiesExpired.length || activitiesCloseToExpired.length)">
    <article class="side-container">
      <div class="notification-pend color-notification" *ngFor="let activity of activitiesExpired" (click)="selectActivity(activity)">
        <span class="text-notification">La actividad: {{activity.attributes.title}} <b>venció hace {{activity.daysLeft * -1}} días.</b><br><b>Estado: </b>Sin entregar</span>
      </div>
      <div class="notification-pend color-notification2" *ngFor="let activity of activitiesCloseToExpired" (click)="selectActivity(activity)">
        <span class="text-notification">La actividad: {{activity.attributes.title}} <b>vence en {{activity.daysLeft}} días.</b><br><b>Estado: </b>Sin entregar</span>
      </div>
    </article>
    <article class="right-container">
        <section class="card-activity" *ngIf="selectedActivity">
            <time class="time-activity-in-card">{{ selectedActivity.attributes.field_date_range.end_value | fechaEs:'daysLeft' }}</time>
            <time class="date-activity-in-card">{{selectedActivity.attributes.field_date_range.end_value | fechaEs: 'date'}}</time>
            <span class="date-activity-in-card">Curso: {{selectedActivity.courseTitle}}</span>
            <span class="title-activity-in-card">{{selectedActivity.attributes.title}}</span>
            <button class="btn-activity-in-card" [routerLink]="['/cursos' + selectedActivity.coursePath + selectedActivity.lessonPath + selectedActivity.attributes.path.alias]">Enviar actividad</button>
        </section>
    </article>
  </section>
  <h1 class="no-notifications" *ngIf="!(activitiesExpired.length || activitiesCloseToExpired.length)">No hay notificaciones para mostrar ¡Te encuentras al día!</h1>
</main>
